module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("same_account", [["div",{},[["p",{},[["textNode",{"text":"Looks like you already have an affiliate account with this email on ModelCentro. You might have registered at affiliates.modelcentro.com or on one of the model's sites before."}]]],["p",{},[["textNode",{"text":"You can login directly to MCProfits with the same credentials."}]]],["p",{},[["textNode",{"text":"If you don't remember your account password, please contact our customer support."}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/common/popuptext.tpl
// module id = 173
// module chunks = 5